import './styles.scss';

import { useApolloClient } from '@apollo/client';
import { Button } from '@ets-global/b2c-website-ui';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { SmallText, TinyText } from '../../components/Base/Text';
import { IDENTITY } from '../../constants';
import { CONTACT_INDIVIDUAL, CONTACT_ORGANISATION } from '../../graphql/mutations';
import errorsHandler from '../../helpers/errorsHandler';
import persistor from '../../helpers/Persistor';
import { useDataLayer, useNotification, useRouter } from '../../hooks';
import { paths } from '../../paths';
import B2BForm from './B2BForm';
import Footer from './Footer';
import Header from './Header';
import IndividualForm from './IndividualForm';

const Contact = () => {
  const apolloClient = useApolloClient();
  const history = useHistory();
  const { currentRoute, generatePath } = useRouter();
  const { pushEventSubmitContactForm, pushEventLoadedB2BContactFunnel, pushEventFormError } = useDataLayer();
  const { newNotification } = useNotification();
  const [isSubmitted, setSubmitted] = useState(false);
  const { t } = useTranslation();

  const handleIdentityChange = (value) => {
    history.push(generatePath(value === IDENTITY.ORGANISATION ? paths.CONTACT_ORGANISATION : paths.CONTACT));
  };

  const handleSubmitForm = (identity) => async (data) => {
    try {
      await apolloClient.mutate({
        mutation: identity === IDENTITY.ORGANISATION ? CONTACT_ORGANISATION : CONTACT_INDIVIDUAL,
        variables: { contact: data },
      });

      pushEventSubmitContactForm(identity === IDENTITY.ORGANISATION);
      if (identity === IDENTITY.ORGANISATION) {
        pushEventLoadedB2BContactFunnel({
          stepName: 'confirmation',
          stepNumber: 4,
        });
      }
      setSubmitted(true);
      window.scrollTo(0, 0);
      persistor.persist('contact_form', {});
    } catch (error) {
      errorsHandler({ error, newNotification, t, pushEventFormError });
    }
  };

  const identities = [
    { value: IDENTITY.INDIVIDUAL, label: t('contact.identity.individual') },
    { value: IDENTITY.ORGANISATION, label: t('contact.identity.professional') },
  ];

  const identity = currentRoute.path === paths.CONTACT_ORGANISATION ? IDENTITY.ORGANISATION : IDENTITY.INDIVIDUAL;

  return (
    <main className="main">
      <Header
        title={t('contact.title')}
        identities={identities}
        isSubmitted={isSubmitted}
        handleIdentityChange={handleIdentityChange}
        identity={identity}
      />

      <main className="contact-form__main">
        <section className="container container--padding">
          {!isSubmitted && identity === IDENTITY.INDIVIDUAL && (
            <IndividualForm handleSubmit={handleSubmitForm(identity)} />
          )}
          {!isSubmitted && identity === IDENTITY.ORGANISATION && <B2BForm handleSubmit={handleSubmitForm(identity)} />}

          {isSubmitted && (
            <div className="contact-form__confirmation">
              <SmallText>
                <Trans>contact.confirmation.sent.title</Trans>
              </SmallText>
              <TinyText>
                <Trans>contact.confirmation.sent.subtitle</Trans>
              </TinyText>
              <Button to={paths.HOME} aria-label={t('contact.confirmation.actions.home')}>
                <Trans>contact.confirmation.actions.home</Trans>
              </Button>
            </div>
          )}
        </section>
      </main>

      <Footer />
    </main>
  );
};

export default Contact;
